import React from "react";
import { motion } from "motion/react";
import logo from "../../../assest/images/logo.png";

const OtpLogo = () => {
  return (
    <motion.div
      initial={{
        scale: 1,
        opacity: 0,
      }}
      animate={{
        scale: 1,
        opacity: 1,
      }}
      exit={{
        scale: 2,
        opacity: 0,
      }}
      transition={{
        duration: 2,
      }}
    >
      <div className="sign-logo">
        <img alt="Your Company" src={logo} />
        <h1>Ashwin cold Forge</h1>
      </div>
    </motion.div>
  );
};

export default OtpLogo;
